import { wechatFinderService } from './instance.js'
import {setStorage} from '@/utils/storage.js'

/**
 * 绑定用户投顾关系
 * @param {*} shareId
 */
export const bindUserAndInvestFinder = async (uid, investId, channel) => {
  await wechatFinderService.post(`/${channel}/invest/share/bind/uid/1`, {
    uid, investId, source: '分享链接', channel
  })
}

/**
 * 通过shareId获取用户分享信息
 * @param {*} shareId
 */
export const rootFinderShare = async (shareId, channel) => {
  const res = await wechatFinderService.get(`/${channel}/uid/invest/gmg/share/get`, {
    params: {
      shareId
    }
  })
  if (res.data.code !== 1) return
  return res.data.data
}

/**
 * 初始化分享记录
 * @param {*} uid
 * @param {*} name
 * @param {*} title
 * @param {*} desc
 */
export const initFinderShare = async (uid, name, title, desc, channel, topic) => {
  const res = await wechatFinderService.post(`/${channel}/uid/invest/gmg/share`, {
    investId: uid, name, title, desc, topic
  })
  return res && res.data && res.data.data && res.data.data.shareId
}
/**
 * 投顾确认分享成功后的回调
 * @param {*} shareId
 */
export const confirmFinderShare = async (shareId, channel) => {
  return wechatFinderService.post(`/${channel}/uid/invest/gmg/share/update`, {
    shareId
  })
}
/**
 * 用户阅读分享之后再次分享
 * @param {*} uid
 * @param {*} shareId
 */
export const spreadFinderShare = async (uid, shareId, channel, title, topic) => {
  return wechatFinderService.post(`/${channel}/uid/invest/gmg/share/update`, {
    watcher: uid, shareId, title, topic
  })
}
/**
 * 用户阅读分享出来的链接
 * @param {*} uid
 * @param {*} shareId
 * @param {*} upper
 */
export const readFinderShare = async (watcher, shareId, upper, channel, title, topic) => {
  const share = await wechatFinderService.post(`/${channel}/uid/invest/gmg/share`, {
    watcher, shareId, upper, title, topic
  })
  const rootShare = await rootFinderShare(shareId, channel)
  if(rootShare && rootShare.investId) {
    const res = await getJobNumberByInvestId(rootShare.investId, channel)
    share.investId = rootShare.investId
    setStorage('INVEST_ID', res)
  }
  await bindUserAndInvestFinder(watcher, rootShare.investId, channel)
  console.log(share,'====-----')
  return share
}
/**
 * 通过investid获取投顾工号
 * @param {*} InvestId
 */
export const getJobNumberByInvestId = async (investId, channel) => {
  const res = await wechatFinderService.get(`/${channel}/get/invest/code`, {
    params: {
      investId
    }
  })
  if (res.data.code !== 1) return
  return res.data.data
}